import React from 'react';
import { Link, navigate } from '@reach/router';
import gql from 'graphql-tag';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import FORGOT_PASSWORD from './forgot-password-mutation';
import classes from './forgot-password.module.scss';
import Form, { IState } from '../../form/form';
import {
  emailValidator,
  required,
  minLength,
  passwordConfirm
} from '../../../validators/form-validators';

const CHANGE_PASSWORD_MUTATION = gql`
  mutation resetPassword($password: String!, $token: String!) {
    resetPassword(password: $password, token: $token) {
      token
    }
  }
`;

export const CheckEmail = ({ email }: any) => {
  return (
    <Card style={{ marginTop: '20px' }}>
      <CardContent>
        <h4>Перевірте свій імейл</h4>
        <p>
          Ми надіслали імейл на адресу {email}. Перейдіть за посиланням в імейлі
          для того щоб відновити свій пароль.
        </p>
      </CardContent>
    </Card>
  );
};

export const PasswordReset = ({ token }: any) => {
  const state: IState = {
    password: {
      label: 'Новий пароль',
      config: {
        type: 'password',
        placeholder: ''
      },
      value: '',
      validators: [required, minLength(6)],
      errorMessage: ''
    },
    confirmPassword: {
      label: 'Повторіть пароль',
      config: {
        type: 'password',
        placeholder: ''
      },
      value: '',
      validators: [required, minLength(6), passwordConfirm],
      errorMessage: '',
      dependency: 'password'
    }
  };

  return (
    <Form
      state={state}
      mutation={CHANGE_PASSWORD_MUTATION}
      submitOptions={{
        keys: ['password'],
        label: 'Змінити пароль',
        id: 'change_password',
        redirectTo: `/`
      }}
      additionalFields={{ token: token ? token : '' }}
    />
  );
};

const ForgotPassword = () => {
  const state: IState = {
    email: {
      label: 'Електронна адреса',
      config: {
        type: 'email',
        placeholder: 'Введіть свою електронну адресу'
      },
      value: '',
      validators: [required, emailValidator],
      errorMessage: ''
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <div>
          <span className={classes.enterPersonalRoomText}>
            Відновити пароль до персонального кабінету
          </span>
          <span className={classes.enterDetailsText}>
            Введіть нижче свої деталі
          </span>
        </div>
        <Link to="/login" style={{ textDecoration: 'none' }}>
          <Button
            data-e2e-id={'login-button'}
            variant="outlined"
            style={{ textTransform: 'capitalize' }}
          >
            Увійти
          </Button>
        </Link>
      </div>
      <Form
        state={state}
        mutation={FORGOT_PASSWORD}
        submitOptions={{
          keys: ['email'],
          label: 'Відновити',
          id: 'restore',
          redirectTo: formState =>
            navigate(`/check-email/${formState.email.value}`)
        }}
      />
    </div>
  );
};

export default ForgotPassword;
